import * as React from 'react';
import { Button, ButtonProps } from './button';
import { Loader2 } from 'lucide-react';

interface SubmitButtonProps extends ButtonProps {
  isLoading?: boolean;
  loadingText?: string;
}

export const SubmitButton = React.forwardRef<HTMLButtonElement, SubmitButtonProps>(
  ({ children, isLoading, loadingText, disabled, ...props }, ref) => {
    return (
      <Button ref={ref} type="submit" disabled={disabled || isLoading} {...props}>
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {loadingText || 'Processing...'}
          </>
        ) : (
          children
        )}
      </Button>
    );
  }
);

SubmitButton.displayName = 'SubmitButton';
